import { navigationRef } from "expo-router/build/global-state/navigationRef";
import { resolveHref } from "expo-router/build/link/href";
import type { Href } from "./types.ts";

/** Resolve the tab reset immediately, before another tab press can change its target. */
export function dismissToSynchronously(href: Href): void {
  navigationRef.current?.dispatchHrefSync(resolveHref(href));
}
